import { ff } from '@atlassian/jira-feature-flagging';

export const isModernGlobalIssueCreateTriggerEnabled = () =>
	ff('project.config.pce.modern.global-issue-create.trigger', false);

export const isRemoveBaseLevelConditionForParentSuggestionsEnabled = () =>
	ff('remove-base-level-condition-for-parent-suggestion-cache_z9a5e', false);

export const isIssueExportControlEnabled = () => ff('dlp-gordian-enabled', false);
